export default "__VITE_ASSET__B3rQsrrP__"